<template>
    <span :class="buttonClasses" @click="doAction">
        <slot></slot>
    </span>
</template>

<script>
export default {
    name: "Button",
    props: {
        size: {
            type: String,
            default: "md",
        },
        cssClasses: {
            type: String,
            default: "btn-primary inline-block",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        action: {
            type: String,
            default: "",
        },
    },
    methods: {
        doAction() {
            if (!this.disabled) {
                this.$emit("buttonClick");
            }
        },
    },
    computed: {
        buttonClasses() {
            return "btn btn-" + this.size + " " + this.cssClasses + ' ' + (this.disabled ? 'btn-disabled' : '');
        },
    },
};
</script>

<style scoped></style>
